/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewArticles_tradeFirm = {
    readonly serviceId: string | null;
    readonly publicProfile: {
        readonly articles: ReadonlyArray<{
            readonly photo: {
                readonly serviceId: string | null;
                readonly path: string | null;
            } | null;
            readonly description: string | null;
            readonly title: string | null;
            readonly webLink: {
                readonly url: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "OverviewArticles_tradeFirm";
};
export type OverviewArticles_tradeFirm$data = OverviewArticles_tradeFirm;
export type OverviewArticles_tradeFirm$key = {
    readonly " $data"?: OverviewArticles_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewArticles_tradeFirm">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewArticles_tradeFirm",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignFirmArticleType",
          "kind": "LinkedField",
          "name": "articles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Photo",
              "kind": "LinkedField",
              "name": "photo",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "WebLink",
              "kind": "LinkedField",
              "name": "webLink",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};
})();
(node as any).hash = '9c974de6c0484e82c3f5fd52ec29e1b8';
export default node;
